var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header-left"},[_vm._v("当前位置："+_vm._s(_vm.info))]),_c('div',{staticClass:"header-right"},[_vm._v("后台管理系统")])])
}
var staticRenderFns = []

export { render, staticRenderFns }